import {ChildNodeChunk} from "../../chunks/types/ChildNodeChunk";
import {getChildNameFromNodeDeclChunk} from "./getChildNameFromNodeDeclChunk";

export function getChildNameFromChildNodeChunk(
  childNodeChunk: ChildNodeChunk
): string {
  const {captures: {1: nodeDeclChunk}} = childNodeChunk;
  return getChildNameFromNodeDeclChunk(nodeDeclChunk);
}
